var _line, _line2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddVersion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 6.72461,
    y1: 10,
    x2: 14.7246,
    y2: 10,
    stroke: "#E33AA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.7246,
    y1: 6,
    x2: 10.7246,
    y2: 14,
    stroke: "#E33AA9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.22461,
    y: 0.5,
    width: 19.2749,
    height: 19,
    rx: 9.5,
    stroke: "#D4D1D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVersion);
export default __webpack_public_path__ + "static/media/addVersion.51de6d1c1af2dacdf1651dee2a0e1296.svg";
export { ForwardRef as ReactComponent };